import React, { ReactElement } from 'react';
import { StyledLoader } from './ModalLoader.style';

export const ModalLoader = (): ReactElement => {
    return (
        <StyledLoader />
    );
};
